export const colors = {
  $primary: "#E18B75",
  $primaryDark: "#122D36",
  $inputGray: "#F4F4F4",
  $darkGray: "#DEDEDE",
};
